import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {goToPage, setProductQuantity, reportDWH} from '../StandAlonePurchaseSaleSlice';
import {ePages} from '../Constants';
import Property from '@episerver/spa-core/Components/Property';
import {getImageSrc} from 'app/utilities/ImageProps';
import AddSubCounter from '../AddSubCounter/AddSubCounter';
import Config from '../../../../Config';
import ProductImage from '../Assets/product.svg';

const ProductPurchasePage = (props) => {
  const [showVIPMsgPopUp, setShowVIPMsgPopUp] = useState(false);
  const [showAdditionDetailsPopUp, setShowAdditionDetailsPopUp] = useState(false);
  const isPriceNotEmptyAndGreaterThanZero = props.productToPurchasePrice !== '' && props.productToPurchasePrice > 0;
  const isDeletedPriceNotEmptyAndGreaterThanZero = props.productToPurchasePriceDeleted !== '' && props.productToPurchasePriceDeleted > 0;
  const isPropertiesNotEmpty = props.productProperties.length > 0;

  function ClickBtn() {
    props.reportDWH({
      actionType: 'Choosing Eq Page Btn Click',
      statusText: 'Ongoing',
      messageText: 'Go to Delivery Address Page',
      param1: props.productQuantity,
    });
    props.goToPage({page: ePages.DELIVERY_PAGE, percent: '40'});
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='product-purchase-page'>
      <div className='product-purchase-page__title'>
        {props.firstName !== '' && <span>{`היי ${props.firstName},`}</span>}
        <span>{props.productPropertiesTitle}</span>
      </div>
      <Property
        className='product-purchase-page__text-after-title'
        context={props.context}
        iContent={props.iContent}
        field='productTextAfterTitle'
      />
      <div className='product-purchase-page__important-area'>
        <Property className='' context={props.context} iContent={props.iContent} field='productImportantToKnowMessage' />
        <div className='product-purchase-page__link-holder'>
          <Image className='product-purchase-page__link-icon' src={getImageSrc(props.iconImageSrc, props.context)} />
          <span className='product-purchase-page__popup-link' onClick={() => setShowVIPMsgPopUp((state) => !state)}>
            {props.productImportantToKnowMessagePopupLink}
          </span>
        </div>
        <PopUp showPopUp={showVIPMsgPopUp} onClose={() => setShowVIPMsgPopUp((state) => !state)}>
          <Property className='' context={props.context} iContent={props.iContent} field='productImportantToKnowMessagePopupTitle' />
          <Image src={getImageSrc(props.mainProductImageSrc, props.context)} alt='popup image' />
        </PopUp>
      </div>
      <div className='product-purchase-page__product-holder'>
        <Property
          className='product-purchase-page__quantity-msg'
          context={props.context}
          iContent={props.iContent}
          field='productQuantityMessage'
        />
        <div className='product-purchase-page__details-holder'>
          <div className='product-purchase-page__section-holder'>
            <div className='product-purchase-page__img-holder'>
              <Image className='product-purchase-page__img'
                src={getImageSrc(props.productToPurchaseImageSrc, props.context)}
                alt='product image' />
              <div className='product-purchase-page__price-details'>
                <div className='product-purchase-page__price-holder'>
                  {isDeletedPriceNotEmptyAndGreaterThanZero && (
                    <span className='product-purchase-page__deleted-price'>{`₪${props.productToPurchasePriceDeleted}`}</span>
                  )}
                  {isPriceNotEmptyAndGreaterThanZero ? (
                    <span className='product-purchase-page__price pink-bold'>{`₪${props.productToPurchasePrice}`}</span>
                  ) : (
                    <span className='product-purchase-page__price pink-bold'>ללא עלות</span>
                  )}
                </div>
                {isPriceNotEmptyAndGreaterThanZero && (
                  <span className='product-purchase-page__text-under-price'>{props.productToPurchaseTextUnderPrice}</span>
                )}
              </div>
            </div>
            <div className='product-purchase-page__product-properties'>
              <span className='product-purchase-page__product-title'>{props.productToPurchaseTitle}</span>
              {isPropertiesNotEmpty && (
                <>
                  <div className='product-purchase-page__product-bullets'>
                    <Image className='product-purchase-page__bullet-icon'
                      src={getImageSrc(props.bulletImageSrc, props.context)}
                      alt='bullet' />
                    <span>{props.productProperties[0]}</span>
                  </div>
                  <div className='product-purchase-page__product-bullets'>
                    <Image className='product-purchase-page__bullet-icon'
                      src={getImageSrc(props.bulletImageSrc, props.context)}
                      alt='bullet' />
                    <span>{props.productProperties[1]}</span>
                  </div>
                </>
              )}
              <PopUp showPopUp={showAdditionDetailsPopUp} onClose={() => setShowAdditionDetailsPopUp((state) => !state)}>
                <div className='product-purchase-page__popup-view'>
                  <div className='product-purchase-page__popup-product'>
                    <Image className='product-purchase-page__img product-purchase-page__img--popup'
                      src={
                        Config.epiBaseUrl +
                        props.productToPurchaseImageSrc /* getImageSrc(props.productToPurchaseImageSrc, props.context) */
                      }
                      alt='product image' />
                    <div className='product-purchase-page__popup-product-details'>
                      <span className='product-purchase-page__product-title'>{props.productToPurchaseTitle}</span>
                      <span>{props.productToPurchaseExtendedText}</span>
                      <div className='product-purchase-page__price-details product-purchase-page__price-details--popup'>
                        <div className='product-purchase-page__price-holder'>
                          {isDeletedPriceNotEmptyAndGreaterThanZero && (
                            <span className='product-purchase-page__deleted-price'>{`₪${props.productToPurchasePriceDeleted}`}</span>
                          )}
                          {isPriceNotEmptyAndGreaterThanZero ? (
                            <span className='product-purchase-page__price pink-bold'>{`₪${props.productToPurchasePrice}`}</span>
                          ) : (
                            <span className='product-purchase-page__price pink-bold'>ללא עלות</span>
                          )}
                        </div>
                        {isPriceNotEmptyAndGreaterThanZero && (
                          <span className='product-purchase-page__text-under-price'>{props.productToPurchaseTextUnderPrice}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {props.productToPurchaseVideo && (
                    <div className='product-purchase-page__popup-video'>
                      <iframe src={props.productToPurchaseVideo}></iframe>
                    </div>
                  )}
                  <div className='product-purchase-page__product-properties'>
                    <span className='product-purchase-page__product-title'>מאפייני השלט</span>
                    <ul>
                      {props.productProperties.map((prp) => {
                        return <li>{prp}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              </PopUp>
              <span onClick={() => setShowAdditionDetailsPopUp((state) => !state)} className='product-purchase-page__more-info'>
                {'לפירוט מלא>'}
              </span>
            </div>
          </div>
          <AddSubCounter
            count={props.productQuantity}
            minValue={1}
            maxValue={props.productMaxQuantityForPurchase}
            increment={() => props.setProductQuantity(props.productQuantity + 1)}
            decrement={() => props.setProductQuantity(props.productQuantity - 1)}
          />
        </div>
        <BtnSubmit text={props.productButtonText === '' ? 'בחירת אופן אספקה' : props.productButtonText} onclick={() => ClickBtn()} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    iContent: state.standAlonePurchaseSaleBlock?.epiContent?.iContent,
    productQuantity: state.standAlonePurchaseSaleBlock?.productQuantity,
    iconImageSrc: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productImportantToKnowMessageIconImage.value?.url ?? '',
    productPropertiesTitle: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productPropertiesTitle?.value ?? '',
    productToPurchaseExtendedText: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseExtendedText?.value ?? '',
    productToPurchaseImageSrc: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseImage?.value?.url ?? '',
    productToPurchaseTitle: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseTitle?.value ?? '',
    mainProductImageSrc: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productImage?.value?.url ?? '',
    productImportantToKnowMessagePopupLink:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productImportantToKnowMessagePopupLink?.value ?? '',
    productMaxQuantityForPurchase: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productMaxQuantityForPurchase?.value ?? '',
    productToPurchasePrice: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchasePrice?.value ?? '',
    productToPurchasePriceDeleted: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchasePriceDeleted?.value ?? '',
    productToPurchaseTextUnderPrice: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseTextUnderPrice?.value ?? '',
    productProperties: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productProperties?.value ?? '',
    productButtonText: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productButtonText?.value ?? '',
    bulletImageSrc: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productBulletImage?.value?.url ?? '',
    productToPurchaseVideo: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseVideo?.value?.url ?? '',
    // other states
    firstName: state.authentication?.loginData?.userDetails?.firstName ?? '',
  };
};

const mapDispatchToProps = {
  goToPage,
  setProductQuantity,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPurchasePage);
